<template>
    <div class="row cart_item underlined_item">
        <div class="col-12 col-lg-8 mt_xxs">
            <div class="media ki_group">
                <div class="ki_p">

                    <template v-if="item.set_part">
                        <div
                            v-if="item.set_part == 'A'"
                            class="cg_i item_icon item_icon_left"
                        >
                            <img src="/i/a.svg" alt="Часть A" />
                        </div>
                        <div
                            v-if="item.set_part == 'B'"
                            class="cg_i item_icon item_icon_left"
                        >
                            <img src="/i/b.svg" alt="Часть B" />
                        </div>
                        <div
                            v-if="item.set_part == 'C'"
                            class="cg_i item_icon item_icon_left"
                        >
                            <img src="/i/c.svg" alt="Часть C" />
                        </div>
                        <div
                            v-if="item.set_part == 'D'"
                            class="cg_i item_icon item_icon_left"
                        >
                            <img src="/i/d.svg" alt="Часть D" />
                        </div>
                    </template>

                    <template v-else>
                        <div
                            v-if="item.is_new"
                            class="cg_i item_icon item_icon_left"
                        >
                            <img src="/i/new.svg" alt="Новинка" />
                        </div>
                        <div
                            v-if="item.is_bestseller"
                            class="cg_i item_icon item_icon_left"
                        >
                            <img src="/i/hit.svg" alt="Новинка" />
                        </div>
                        <div
                            v-if="item.is_sale"
                            class="cg_i item_icon item_icon_left"
                        >
                            <img src="/i/sale.svg" alt="Новинка" />
                        </div>
                    </template>

                    <a :href="'/catalog/item/' + item.slug">
                        <div v-if="item.images.length > 0" 
                            class="item_picture">
                                <div class="preview-image"
                                    :style="
                                        'background-image: url(/storage/' +
                                        item.images[0].path
                                    "
                                ></div>
                        </div>
                        <div v-else
                            class="item_picture item_picture_no-image">
                                <div class="no-image"></div>
                        </div>
                    </a>
                </div>

                <div class="media-body">
                    <div class="ki_title subtitle">
                        <a :href="'/catalog/item/' + item.slug">{{ item.title }}</a>
                    </div>

                    <div class="ki_info item_info item_info_horizontal">
                        <p v-if="item.attr_color"><span>Цвет</span> {{ item.attr_color }}</p>
                        <p v-if="item.attr_size"><span>Размер</span> {{ item.attr_size }}</p>
                        <p v-if="item.attr_material"><span>Материал</span> {{ item.attr_material }}</p>
                        <p v-if="item.attr_type"><span>Тип</span> {{ item.attr_type }}</p>
                        <p v-if="item.country"><span>Производитель</span> {{ item.country }}</p>
                        <p v-if="item.attr_other"><span>Прочее</span> {{ item.attr_other }}</p>
                        <p><span>Артикул</span> {{ item.sku }}</p>
                    </div>
                    <div class="ki_small small_info">
                        <span v-if="item.status == 1" class="stock_xs">В наличии.</span>
                        <span v-else-if="item.status == 3" class="stock_some_xs">Заканчивается.</span>
                        <span v-else-if="item.status == 2" class="stock_gone_xs">Нет в наличии.</span>
                        <span v-else-if="item.status == 4" class="stock_request_xs">Под заказ.</span>
                        <span v-else class="stock_gone_xs">Нет в наличии.</span>

                        В упаковке по
                        <span class="accent">{{ item.qty_per_pack }} {{ item.unit }}</span>
                        <!--
        <span class="sale_xs">Скидка 10% за объем.</span>
        -->
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-4 mt_xxs">
            <div class="ki_price">
                
                <span v-if="item.old_price && item.old_price !== item.price" class="other_lg">
                    <s>{{ item.old_total }} р.</s>
                </span>

                <span class="price_lg">
                    {{ item.total }} р.
                    </span>
            </div>

            <div class="ki_action">
                <div class="input-group input_num">
                    <div class="input-group-prepend">
                        <button
                            class="btn btn_lg btn_form"
                            type="button"
                            @click.prevent="minus(item.id)"
                        >
                            <i class="f7-icons icon_sm">minus_circle</i>
                        </button>
                    </div>
                    <input
                        type="text"
                        class="form-control input_w_btn"
                        placeholder="0"
                        :value="item.qty"
                        @change.prevent="setQty(item.id, $event.target.value)"
                    />
                    <div class="input-group-append">
                        <button
                            :id="'add-to-cart-plus-' + item.id"
                            class="btn btn_lg btn_form"
                            type="button"
                            @click.prevent="plus(item.id)"
                        >
                            <i class="f7-icons icon_sm">plus_circle</i>
                        </button>
                        <b-popover
                            :ref="'plusPopover' + item.id"
                            :target="'add-to-cart-plus-' + item.id"
                            :disabled.sync="popoverIsDisabled"
                            placement="bottom">
                            Выбрано максимальное количество
                        </b-popover>
                    </div>
                </div>

                <div class="ki_move small_list">
                    <a href="#" @click.prevent="deleteFromCart(item.id)">Удалить</a>
                    <a v-if="!inFavourites(item.id)" href="#" @click.prevent="addToFavourites(item.id)">В избранное</a>
                    <a v-else href="#" @click.prevent="deleteFromFavourites(item.id)">В избранном</a>
                </div>
            </div>
        </div>

        <div class="col-12" v-if="item.qty > item.qty_in_stock">
            <div class="cart_item_alert mt_xxs">
                <b>{{ item.qty_in_stock }} ед.</b> доступно на складе из добавленных в корзину {{ item.qty }} ед. 

                <a href="#" v-if="inInforms(item.id)" data-toggle="modal" :data-target="'#modelInformUnsubscribe' + item.id">Вы подписаны на товар</a>
                <a href="#" v-else data-toggle="modal" :data-target="'#modelInform' + item.id">Сообщить о поступлении</a>

                <inform-modal v-if="isAuth" :id="item.id" :email="email"></inform-modal>
                <inform-modal v-else :id="item.id"></inform-modal>
                
                <inform-unsubscribe-modal :id="item.id"></inform-unsubscribe-modal>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['item', 'set'],

    data: function () {
        return {
            popoverIsDisabled: true,
        };
    },

    methods: {
        deleteFromCart(id) {
            let params = {
                id: id,
                set: this.set,
                qty: this.qty,
                title: this.item.title,
                sku: this.item.sku,
                category: this.item.category,
                price: this.item.price,
            };

            this.$store.dispatch('cart/deleteFromCart', params);
        },

        plus(id) {
            this.$refs['plusPopover' + id].$emit('close');

            let params = {
                id: id,
                set: this.set,
            };

            axios.put('/ajax/cart/plus', params)
                .then(request => {
                    this.$store.commit('cart/setQty', { id: id, set_id: this.set, qty: request.data.totalQty });
                    this.$store.dispatch('cart/getCart');
                    
                    let products =  [{
                        "id": request.data.sku,
                        "name": request.data.title,
                        "price": request.data.price,
                        "category": request.data.category,
                        "quantity": request.data.qty
                    }];

                    // metrika
                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({
                        "ecommerce": {
                            "currencyCode": "RUB",    
                            "add": {
                                "products": products
                            }
                        }
                    });

                    if(!request.data.success) {
                        this.$refs['plusPopover' + id].$emit('open');

                        setTimeout(() => {
                            this.$refs['plusPopover' + id].$emit('close');
                        }, 3000);
                    }
                });
        },

        minus(id) {
            this.$refs['plusPopover' + id].$emit('close');
            
            let params = {
                id: id,
                set: this.set,
            };

            this.$store.dispatch('cart/minus', params);
        },

        setQty(id, qty) {
            this.$refs['plusPopover' + id].$emit('close');

            let params = {
                id: id,
                qty: qty,
            };

            axios.put('/ajax/cart/qty', params)
                .then(request => {
                    this.$store.commit('cart/setQty', { id: id, set_id: this.set, qty: request.data.qty });
                    this.$store.dispatch('cart/getCart');

                    if(!request.data.success) {
                        this.$refs['plusPopover' + id].$emit('open');

                        setTimeout(() => {
                            this.$refs['plusPopover' + id].$emit('close');
                        }, 3000);
                    }
                });
        },

        inFavourites(id) {
            return this.$store.state.favourites.items.find(x => x.id == id);
        },

        addToFavourites(id) {
            this.$store.dispatch('favourites/addToFavourites', id)
        },
        
        deleteFromFavourites(id) {
            this.$store.dispatch('favourites/deleteFromFavourites', id)
        },

        inInforms(id) {
            return this.$store.state.informs.items.find(x => x.id == id);
        }
    },
    computed: {
        isAuth() {
            return this.$store.state.isAuth;
        },
        
        email() {
            return this.$store.state.email;
        },
    },
};
</script>
